import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { PopupInfoComponent } from 'src/app/shared/components/popup-info/popup-info.component';
import { QuestionVM } from 'src/app/shared/models/model/concretes/components/question.model';

@Component({
  selector: 'app-question',
  templateUrl: './question.component.html',
  standalone: true,
  imports: [CommonModule, PopupInfoComponent]
})
export class QuestionComponent implements OnInit {
  @Input() question!: QuestionVM;

  constructor() {}

  ngOnInit() {}
}
